export default __webpack_public_path__ + "static/media/AccentColorPreview.d7bb1970.png";